import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setUserData } from "../../actions/userActions";
import ActiveFormModal from "../ActiveFormModal";
import defaultimg from "../../assets/img/dummy.jpeg";
// import cover from "../../assets/img/profiles/avatar-08.jpg";

const AdminCustomersListRow = ({ current, i }) => {
  const [selectedImage, setSelectedImage] = useState(defaultimg);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  //   console.log(current, "current");
  const [showActiveModal, setshowActiveModal] = useState(false);
  const openActiveModal = () => {
    setshowActiveModal((showActiveModal) => !showActiveModal);
  };
  console.log(current, "currenttttttt user list");

  return (
    <>
      <tr>
        <td>{i + 1}</td>
        <td>
          {current?.profilePic && current?.profilePic?.fileUrl ? (
            <img
              className="default-pic-height rounded border"
              src={current?.profilePic?.fileUrl}
              alt="Profile Pic"
              width="50"
              height="50"
              // style={{ borderRadius: "50%", height: "100%", width: "100%" }}
            />
          ) : (
            <img
              className="default-pic-height rounded border"
              src={selectedImage}
              alt="Profile Pic"
              width="50"
              height="50"
              // style={{ borderRadius: "50%", height: "100%", width: "100%" }}
            />
          )}
        </td>
        <td>{current?.firstName + " " + current?.lastName}</td>
        <td>{current?.phone ? current?.phone : "-"}</td>
        <td>{current?.email ? current?.email : "-"}</td>
        <td>
          {/* {current.status === true ? (
            <a
              href="#"
              className="btn btn-sm btn-success"
              onClick={openActiveModal}
            >
              Active
            </a>
          ) : (
            <a
              href="#"
              className="btn btn-sm btn-dark"
              onClick={openActiveModal}
            >
              Deactivated
            </a>
          )} */}
          <Link
            to={`/user-details/${current.id}`}
            className="btn btn-sm btn-primary mx-1"
            onClick={() => {
              dispatch(setUserData(current));
              // navigate(`/order-details/${current.id}`);
            }}
          >
            View
          </Link>
          <a href="#" className="btn btn-sm btn-danger">
            Delete
          </a>
        </td>
      </tr>
      <ActiveFormModal
        openActiveModal={openActiveModal}
        showActiveModal={showActiveModal}
        current={current}
      />
    </>
  );
};

export default AdminCustomersListRow;
